function initializeNavigation() {
  // Set the width of the mobile viewport
  const breakpointWidth = 1201;

  // Get the navigation element or exit if it does not exist
  const navigation = document.querySelector("nav#header-navigation");
  if (!navigation) return;
  // Get the toggle buttons for the overlays or exit if one doesn't exist
  const mainToggle = navigation.querySelector("#navigation-flyout-open");
  const serviceToggle = navigation.querySelector("#navigation-flyout-service");
  const serviceMobileToggle = navigation.querySelector("#navigation-flyout-service-mobile");
  const closeToggle = navigation.querySelector("#navigation-flyout-close");
  const mobileOverlayBack = navigation.querySelector("#navigation-flyout-back");
  const mobileOverlayTitle = navigation.querySelector("#navigation-mobile-title");
  if (!mainToggle || !serviceToggle || !closeToggle || !serviceMobileToggle || !mobileOverlayBack || !mobileOverlayTitle) return;
  // Get the overlay elements or exit if one doesn't exist
  const mainOverlay = navigation.querySelector("#nav-overlay-main");
  const serviceOverlay = navigation.querySelector("#nav-overlay-service");
  if (!mainOverlay || !serviceOverlay) return;
  // Get the logo variants or exit if one doesn't exist
  const logoDefault = navigation.querySelector("#nav-logo-default");
  const logoSmall = navigation.querySelector("#nav-logo-small");
  if (!logoDefault || !logoSmall) return;
  // Get the labels for the overlays on mobile viewports
  const mainOverlayLabel = mainToggle.dataset.mobileLabel;
  const serviceOverlayLabel = serviceMobileToggle.dataset.mobileLabel;
  // Add variavle to store the users scroll position
  let scrollPosition = 0;

  /**
   * Close all active overlays, handle the logo and toggle buttons
   */
  function closeOverlays(event) {
    // Prevent default behavior
    if (event) event.preventDefault();
    // Remove class for open overlay on navigation
    navigation.classList.remove("active");
    // Set body back to default
    document.body.style.height = "auto";
    // Set the users scroll position if one of the overlays is active
    if (
      mainOverlay.classList.contains("active") ||
      serviceOverlay.classList.contains("active")
    ) {
      if (event) event.preventDefault();
      window.scrollTo(0, scrollPosition);
    }
    // Close overlays
    mainOverlay.classList.remove("active");
    serviceOverlay.classList.remove("active");
    // Handle toggle buttons
    mainToggle.classList.add("active");
    closeToggle.classList.remove("active");
    // Handle logo
    logoDefault.classList.add("active");
    logoSmall.classList.remove("hidden");
    logoSmall.classList.remove("active");
    mobileOverlayBack.classList.remove("active");
    // Handle labels for mobile viewports
    mobileOverlayTitle.innerHTML = "";
    // Set scroll behavior on the html element back to smooth
    document.documentElement.style.scrollBehavior = "smooth";
  }

  /**
   * Open the given overlay, handle the logo and toggle buttons
   */
  function openOverlay(overlay, event) {
    // Prevent default behavior
    if (event) event.preventDefault();
    // Close all overlays
    closeOverlays(event);
    // Set class for open overlay on navigation
    navigation.classList.add("active");
    // Open the given overlay
    overlay.classList.add("active");
    // Handle toggle buttons
    mainToggle.classList.remove("active");
    closeToggle.classList.add("active");
    // Check if viewport is mobile
    if (window.innerWidth < breakpointWidth) {
      // Handle logo
      logoDefault.classList.remove("active");
      // If the overlay is the main overlay, show the small logo
      if (overlay === mainOverlay) {
        logoSmall.classList.add("active");
        // Set the label for the title of the overlay
        mobileOverlayTitle.innerHTML = mainOverlayLabel;
      }
      // If the overlay is the service overlay, show the back button
      if (overlay === serviceOverlay) {
        logoSmall.classList.add("hidden");
        mobileOverlayBack.classList.add("active");
        // Set the label for the title of the overlay
        mobileOverlayTitle.innerHTML = serviceOverlayLabel;
      }
    }
    // Set the users scroll position
    scrollPosition = window.pageYOffset;
    // Set body to 100vh to prevent second scroll bar
    document.body.style.height = "100vh";
    // Set scroll behavior on the html element to default
    document.documentElement.style.scrollBehavior = "auto";
  }

  /**
   * Add event listeners to the toggle buttons, escape key and the document
   */
  function addEventListeners() {
    // Add event listeners to the toggle buttons
    mainToggle.addEventListener("click", (event) => openOverlay(mainOverlay, event));
    serviceToggle.addEventListener("click", (event) => openOverlay(serviceOverlay, event));
    serviceMobileToggle.addEventListener("click", (event) => openOverlay(serviceOverlay, event));
    closeToggle.addEventListener("click", (event) => closeOverlays(event));
    mobileOverlayBack.addEventListener("click", (event) => openOverlay(mainOverlay, event));

    // Close all overlays when clicking outside of the navigation
    document.addEventListener("click", (event) => {
      if (!navigation.contains(event.target)) {
        closeOverlays();
      }
    });

    // Close all overlays when pressing the escape key
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeOverlays();
      }
    });
  }

  // Add event listeners
  addEventListeners();
}

export default initializeNavigation;
